import { render } from "./reportIndex.vue?vue&type=template&id=195a596e&scoped=true"
import script from "./reportIndex.vue?vue&type=script&lang=js"
export * from "./reportIndex.vue?vue&type=script&lang=js"

import "./reportIndex.vue?vue&type=style&index=0&id=195a596e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195a596e"]])

export default __exports__